import { useQuery, useMutation } from '@apollo/client';
import { Container } from 'components/Container/Container';
import { EmptyState } from 'components/EmptyState/EmptyState';
import { Loader } from 'components/Loader/Loader';
import { PageTitle } from 'components/PageTitle/PageTitle';
import React from 'react';
import { PENDING_PROFILE_CHANGES, APPROVE_PROFILE_CHANGE, REJECT_PROFILE_CHANGE } from 'services/profileChanges';

import { ProfileChangeCard } from './_components/ProfileChangeCard';

export const ProfileChangesList: React.FC = () => {
    const { data, loading, refetch } = useQuery(PENDING_PROFILE_CHANGES, {
        variables: { status: 'PENDING', first: 50 },
    });

    const [approveChange] = useMutation(APPROVE_PROFILE_CHANGE, {
        onCompleted: () => refetch(),
    });

    const [rejectChange] = useMutation(REJECT_PROFILE_CHANGE, {
        onCompleted: () => refetch(),
    });

    if (loading) return <Loader />;

    const changes = data?.profileChangeRequests?.edges || [];

    return (
        <Container>
            <PageTitle>Pending Profile Changes</PageTitle>

            {changes.length === 0 ? (
                <EmptyState title="No pending profile changes" text="All profile change requests have been processed." />
            ) : (
                <div className="space-y-4">
                    {changes.map(({ node }: any) => (
                        <ProfileChangeCard
                            key={node.id}
                            changeRequest={node}
                            onApprove={(comment) =>
                                approveChange({
                                    variables: { id: node.id, comment },
                                })
                            }
                            onReject={(comment) =>
                                rejectChange({
                                    variables: { id: node.id, comment },
                                })
                            }
                        />
                    ))}
                </div>
            )}
        </Container>
    );
};
